export const colorsDictionary = [
  {
    category: 'COVID-19',
    color: '#007C1F'
  },
  {
    category: 'PROMOCIÓN RPCh',
    color: '#FF3366'
  },
  {
    category: 'SOLIDARIDAD INTERNACIONAL Y COOPERACIÓN SUR - SUR',
    color: '#9966FF'
  },
  {
    category: 'AVANCES TECNOLÓGICOS RPCh',
    color: '#65327E'
  },
  {
    category: 'ORGANISMOS FOROS Y ESPACIOS MULTILATERALES',
    color: '#666600'
  },
  {
    category: 'RELACIONES BINACIONALES RPCh - ALC',
    color: '#6699FF'
  },
  {
    category: 'GOBIERNO RPCh',
    color: '#33CC99'
  },
  {
    category: 'EE.UU.',
    color: '#996633'
  },
  {
    category: 'VERACIDAD INFORMACIÓN',
    color: '#CCAAFF'
  },
  {
    category: 'Ciudadano',
    color: '#0042A1'
  },
  {
    category: 'Gobiernos y Entidades Gubernamentales ALC',
    color: '#669999'
  },
  {
    category: 'Cuenta Suspendida o Eliminada',
    color: '#cccccc'
  },
  {
    category: 'Empresas y Organizaciones Privadas ALC',
    color: '#006699'
  },
  {
    category: 'Medios de comunicación y Sites de Promoción RPCh',
    color: '#0099ff'
  },
  {
    category: 'Organizaciones Binacionales RPCh - ALC',
    color: '#663300'
  },
  {
    category: 'Centros de Investigación y Educación Superior ALC',
    color: '#669900'
  },
  {
    category: 'Influencers',
    color: '#990099'
  },
  {
    category: 'Organismos Foros y Espacios Multilaterales',
    color: '#666600'
  },
  {
    category: 'Medios de Comunicación ALC',
    color: '#006600'
  },
  {
    category: 'Gobierno RPCh',
    color: '#33CC99'
  },
  {
    category: 'N/A',
    color: '#cccccc'
  },
  {
    category: 'MEDIO AMBIENTE Y BIODIVERSIDAD',
    color: '#ff9900'
  },
  {
    category: 'Amplificador de Contenido',
    color: '#a399CC'
  },
  {
    category: 'Cuenta suspendida o Eliminada',
    color: '#CFa'
  },
  {
    category: 'Gobiernos Extranjeros',
    color: '#ff99aa'
  },
  {
    category: 'BOT',
    color: '#cc11cc'
  },
  {
    category: 'Medios de Comunicación Extranjeros',

    color: '#ABC'
  },
  {
    category: 'Empresas Extranjeras',
    color: '#aa11ff'
  },
  {
    category: 'Ciudadano RPCh o Taiwán',
    color: '#aaafff'
  },
  {
    category: 'EMPRESAS ALC',
    color: '#AFFaaf'
  },
  {
    category: 'Empresas RPCh',
    color: '#1ffa11'
  }
]
